// Deal locations arrive as free text ("Woodbrook Cemetery, Port of Spain, Trinidad and Tobago")
// and the country is stored separately ("Trinidad & Tobago"). Printing both gives you the country
// twice and a six-line address inside a card. Keep it to the useful part.
const norm = (s) => (s || "").toLowerCase().replace(/\band\b/g, "&").replace(/[^a-z&]/g, "");

export const placeLabel = (location, country, maxParts = 2) => {
  const parts = String(location || "").split(",").map((p) => p.trim()).filter(Boolean);
  const c = norm(country);
  const kept = parts.filter((p) => !c || norm(p) !== c).slice(0, maxParts);
  const head = kept.join(", ");
  if (!head) return country || "";
  if (!country || norm(head).includes(c)) return head;
  return `${head}, ${country}`;
};
